module.exports = __webpack_public_path__ + "media/images/front/event/person-icon-d644bf104b5eae45d66bdd75d621f19c.svg";